import * as Yup from 'yup';

import { filePayloadArrayValidationSchema } from 'src/components/validation/FilePayloadArrayValidationSchema';
import type { IVendorLeadConditionStepFormValues } from 'src/components/vendors/VendorLeadTypes';
import {
  formProductLeadSpecificationEditValidationSchema,
  toFormVendorProductLeadSpecificationEditInitialValues,
} from 'src/components/vendors/VendorLeadValidation';
import { fileReferencesToFilePayloads } from 'src/helpers';
import type { IFileReference } from 'src/types';
import type { IProductSpecificationFieldReference } from 'src/types/reference/IProductSpecificationReference';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export const vendorLeadProductConditionValidationSchema = (fields: IProductSpecificationFieldReference[]) =>
  formProductLeadSpecificationEditValidationSchema(fields).concat(
    Yup.object<IVendorLeadConditionStepFormValues>().shape({
      sdsFiles: filePayloadArrayValidationSchema.min(0),
    })
  );

export const vendorLeadProductConditionInitialValues = (
  sdsFiles: IFileReference[],
  fields: IProductSpecificationFieldReference[],
  vendorLeadProduct?: IVendorLeadProduct
): IVendorLeadConditionStepFormValues => ({
  ...toFormVendorProductLeadSpecificationEditInitialValues(fields, vendorLeadProduct),

  sdsFiles: fileReferencesToFilePayloads(sdsFiles),
});
